<h1 class="colorSearch" mat-dialog-title>INVIA SEGNALAZIONI</h1>
<div mat-dialog-content>
    <div class="flex-row">
        <b>Clicca su invia segnalazioni per inviare le segnalazioni</b>
    </div>
    <br>
    <div class="flex-row">
        <mat-checkbox [labelPosition]="'before'" (change)="confermaInvio($event)" [disabled]="confermaInvioSegnalazioni">Conferma l'invio delle
            segnalazioni</mat-checkbox>
    </div>
    <br [hidden]="!confermaInvioSegnalazioni">
    <div class="flex-row" [hidden]="!confermaInvioSegnalazioni">
        <p>Identificativo invio: {{ idInvio }} </p>
    </div>
    <br [hidden]="!confermaInvioSegnalazioni">
    <div class="flex-row" [hidden]="!confermaInvioSegnalazioni">
        <p>Effettua il download del File Pdf: <span *ngIf="idInvioGenerato" (click)="downloadSegnalazioniDaInviarePdf()" class="fake-link" download>{{nomeFilePdf}}</span></p>
    </div>
    <br [hidden]="!confermaInvioSegnalazioni">
    <div class="flex-row" [hidden]="!confermaInvioSegnalazioni">
        <p>Effettua il download del File Excel: <span *ngIf="idInvioGenerato" (click)="downloadSegnalazioniDaInviareExcel()" class="fake-link" download>{{nomeFileExcel}}</span></p>
    </div>
    <br [hidden]="!documentiLetti()">
    <div class="flex-row">
        <mat-checkbox [labelPosition]="'before'" (change)="confermaLettura($event)" [hidden]="!documentiLetti()">
            Ho scaricato i file PDF ed Excel relativi alle<br>
            segnalazioni e ho verificato che siano corretti.</mat-checkbox>
    </div>

</div>
<hr>
<mat-dialog-actions align="end">
    <button mat-stroked-button color='accent' class='persBtn' mat-dialog-close>
        <p class='cont'>ANNULLA</p>
    </button>
    <button mat-raised-button color='accent' class='persBtn' [disabled]="!confermaDocumentoLetto" (click)=inviaSegnalazioni()>
        <p class='cont'>CONFERMA INVIO</p>
    </button>
</mat-dialog-actions>
